import { render } from "./Dialog.vue?vue&type=template&id=61dd66f0&ts=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=61dd66f0&lang=scss"

import exportComponent from "C:\\work\\h5\\yulinxing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__